let windowWidth;

function updateSize() {
  windowWidth = window.innerWidth;
  const tryProductContainer = document.querySelector('.try-products');
  const tryProductsSlider = tryProductContainer.querySelector('.try-products-container');
  const tryProducts = tryProductsSlider.querySelectorAll('.try-product');
  if(windowWidth > 650) {
    tryProducts.forEach((el) => {
        el.style = "";
    });
  }
  else {
    tryProducts.forEach((el) => {
        calcTryProductParams(el, tryProductsSlider);
    });
  }
}

window.addEventListener("resize", updateSize);

function calcTryProductParams(el, tryProductsSlider) {
    let left = el.getBoundingClientRect().left;
    let opacity = left / tryProductsSlider.clientWidth * 0.75 - 0.1;
    left = left - 39;
    const height = left / tryProductsSlider.clientWidth * 0.2 + 1;
    let heightScale = left / tryProductsSlider.clientWidth * 0.1 + 1;

    if(opacity > 0.95) opacity = 1;
    if(heightScale > 1) heightScale = 1 - (heightScale - 1);
    if(heightScale > 1) heightScale = 1;

    // translating because scaling is done in relation to the center of the element
    let translateY = (1 - heightScale) / 2 * 100;
    if(translateY < 0) translateY = 0;

    el.style.opacity = 1 - Math.abs(opacity);
    el.style.transform = "scale(1, " + heightScale + ") translateY(" + translateY + "%)";
}

document.addEventListener("DOMContentLoaded", () => { 
    updateSize();

    const tryProductContainer = document.querySelector('.try-products');
    const goBackBtn = tryProductContainer.querySelectorAll('.try-products__back');
    const productSelects = tryProductContainer.querySelectorAll('.try-product__content-wrapper');
    const productOptions = tryProductContainer.querySelectorAll('.try-products__options');
    const checkoutButtons = tryProductContainer.querySelectorAll('.bttn');
    const tryProductsSlider = tryProductContainer.querySelector('.try-products-container');
    const tryProducts = tryProductsSlider.querySelectorAll('.try-product');

    tryProductsSlider.addEventListener('scroll', () => {
        if(windowWidth > 650) return;
        tryProducts.forEach((el) => {
            calcTryProductParams(el, tryProductsSlider);
        });
    })

    productSelects.forEach((el) => {
        el.addEventListener('click', () => {
            tryProductContainer.dataset.activeProduct = el.dataset.productIndex;
            tryProductContainer.dataset.activeOption = 1;
            tryProductContainer.dataset.activeStep = 2;
            window.scrollTo({ top: 0 });
        });
    });

    goBackBtn.forEach((el) => {
        el.addEventListener('click', () => {
            tryProductContainer.dataset.activeStep = 1;
            window.scrollTo({ top: 0 });
        });
    })

    productOptions.forEach((productOption) => {
        const optionContainers = productOption.querySelectorAll('.try-product-option');
        optionContainers[0].querySelector('input').checked = true;
        optionContainers.forEach((el) => {
            el.addEventListener('click', () => {
                el.querySelector('input').checked = true;
                tryProductContainer.dataset.activeOption = el.dataset.optionIndex;
            });
        });
    });

    checkoutButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            window.location.href = btn.dataset.link;
        });
    });
});